import React, { useState } from "react"
import { OptionsPicker } from "../components/optionsPicker"
import { useSfx } from "../hooks/use-sfx.js"
import styles from "../styles/bio.module.css"

function BioText({ bioDifficulty }) {
  const getVisibility = group => {
    const mappings = {
      very_easy: [],
      easy: ["easy"],
      normal: ["easy", "normal"],
      hard: ["easy", "normal", "hard"],
      very_hard: ["easy", "normal", "hard", "very_hard"],
    }

    const visibility = mappings[bioDifficulty]

    return visibility.includes(group) ? "inline" : "none"
  }
  const yearsWorking = new Date().getFullYear() - 2015

  return bioDifficulty ? (
    <div>
      <p>
        <strong>André Pasquali</strong> is a Unity Software Engineer
        <span style={{ display: getVisibility("easy") }}>
          {" "}
          with {yearsWorking}+ years of experience
          <span style={{ display: getVisibility("hard") }}>
            {" "}
            in building high-impact games and apps
          </span>
          <span style={{ display: getVisibility("very_hard") }}>
            {" "}
            for leading companies in different fields
          </span>
        </span>
        .
        <br />
      </p>

      <p>
        <span style={{ display: getVisibility("easy") }}>
          {" "}
          He currently works as a Unity Developer at{" "}
          <a href="https://yallaplay.com/">YallaPlay</a>
          <span style={{ display: getVisibility("normal") }}>
            {" "}
            where he developing new features for his game Spades Masters published by MiniClip S.A with the highest technical standards
          </span>
          <span style={{ display: getVisibility("hard") }}>
            , using a broad set of technologies and tools to build amazing and cool things in a colaborative environment that reaches
            millions of people
          </span>
          .
          <br />
        </span>
      </p>

      <p>
        <span style={{ display: getVisibility("very_hard") }}>
          {" "}
          The multi-faceted nature of developing software and the drive to
          always learn something new is what excites him most about the
          profession.
          <br />
        </span>{" "}
        He was born in Brazil
        <span style={{ display: getVisibility("easy") }}>
          {" "}
          and living in Ribeirão Preto - São Paulo
        </span>
        <span style={{ display: getVisibility("hard") }}>
          {" "}
          
        </span>
        .
      </p>
    </div>
  ) : null
}

export function Bio() {
  const [bioDifficulty, setBioDifficulty] = useState("normal")
  const bioDifficulties = ["very_easy", "easy", "normal", "hard", "very_hard"]
  const { playClick, playPop } = useSfx()

  const clickHandler = difficulty => {
    setBioDifficulty(difficulty)
  }

  return (
    <div className={styles.container}>
      <div className={styles.mainTitleContainer}>
        <i className={`${styles.titleIcon} nes-icon is-medium star`}></i>
        <h2 className={styles.mainTitle}>André's Bio</h2>
        <i className={`${styles.titleIcon} nes-icon is-medium star`}></i>
      </div>

      <div className={styles.sideContainer}>
        <OptionsPicker
          title="Select Difficulty"
          selectedOption={bioDifficulty}
          options={bioDifficulties}
          hoverSound={playPop}
          clickSound={playClick}
          clickHandler={clickHandler}
        />
      </div>
      <div
        className={`nes-container is-rounded is-dark ${styles.sideContainer} ${styles.bio}`}
      >
        <BioText bioDifficulty={bioDifficulty} />
      </div>
    </div>
  )
}
